import React, { useState, useRef } from "react";
import Popover from "react-tiny-popover";

import Icon from "../Icon";
import MedicationFunds from "./MedicationFunds";

const Medication = (props) => {
  const popoverEl = useRef(null);
  const [open, setOpen] = useState(false);

  const toggleOpen = (event) => {
    event.preventDefault();
    setOpen(!open);
  };

  return (
    <Popover
      isOpen={open}
      onClickOutside={() => setOpen(false)}
      contentDestination={popoverEl.current}
      contentLocation={{ top: -30, left: 0 }}
      style={{ maxWidth: "100%" }}
      disableReposition
      content={
        <MedicationFunds
          medication={props.medication}
          toggleOpen={toggleOpen}
        />
      }
    >
      <div style={{ position: "relative" }}>
        <button
          className="Glossary-term-btn"
          onClick={(event) => toggleOpen(event)}
        >
          <span className="Glossary-term">{props.medication.Name}{" "}</span>
        </button>

        <div
          style={{
            position: "absolute",
            zIndex: 100,
            width: "100%",
          }}
          ref={popoverEl}
        ></div>
      </div>
    </Popover>
  );
};

export default Medication;
